import * as React from "react";
import { useThemedAsset } from "../../hooks/use-themed-asset";
import { useCopy } from "../../containers";
import { Quote } from "../../atoms";

import "./header.scss";

interface IHeaderProps {
  copy: {
    message: string;
  };
}
export const Header: React.FC<IHeaderProps> = ({ copy: { message } }) => {
  const logo = useThemedAsset("/images/{theme}/shop/logo.png");
  const baseClassName = "header";

  return (
    <div className={baseClassName}>
      <img className={`${baseClassName}__logo`} src={logo} alt="" />

      <Quote>{message}</Quote>
    </div>
  );
};

export const HeaderContainer: React.FC = props => {
  const copy = useCopy("header");

  return <Header {...props} copy={copy} />;
};
